module.exports = __webpack_public_path__ + "../front/img/768_4_skuffer+hylder.6ce06786.svg";